import { Switch } from '@thanx/uikit/switch'
import { useGetDashboardQuery } from 'api/insightsLab'
import Loading from 'components/Loading'
import useCurrentMerchant from 'hooks/useCurrentMerchant'
import { Container } from 'react-bootstrap-five'
import { RouteComponentProps } from 'react-router-dom'
import LookerFooter from 'scenes/LookerEmbed/components/LookerFooter'
import LookerIframe from 'scenes/LookerEmbed/LookerIframe'
import InsightsLabBanner from '../InsightsLabBanner'

type Props = RouteComponentProps<{ id: string }>

const InsightsLabLanding = ({ match }: Props) => {
  const { data: dashboard, isLoading } = useGetDashboardQuery(match.params.id)
  const merchant = useCurrentMerchant()

  if (!merchant) return null

  return (
    <Container fluid className="grey-05-bkg border-top-1 grey-20-border">
      <Container className="full-height">
        <InsightsLabBanner />
        <Switch
          condition={!isLoading}
          fallback={
            <div style={{ height: '80vh' }}>
              <Loading />
            </div>
          }
        >
          <LookerIframe
            path={'dashboards/' + dashboard?.id}
            merchant={merchant}
            height="80vh"
          />
        </Switch>
        <LookerFooter className="my-xl" />
      </Container>
    </Container>
  )
}

export default InsightsLabLanding
